import { Injectable } from '@angular/core';

@Injectable()
export class UbiMsgCenterService {

  private _notifications = [
    {
      name: 'Vlad',
      text: 'New Booking',
      time: '1 min ago'
    },
    {
      name: 'Kostya',
      text: 'New Booking',
      time: '2 hrs ago'
    },
    {
      image: 'assets/img/shopping-cart.svg',
      text: 'EDI Alert',
      time: '5 hrs ago'
    },
    {
      name: 'Andrey',
      text: 'New Booking',
      time: '1 day ago'
    },
    {
      name: 'Nasta',
      text: 'New Booking',
      time: '2 days ago'
    },
    {
      image: 'assets/img/comments.svg',
      text: 'EDI Error',
      time: '3 days ago'
    },
    {
      name: 'Kostya',
      text: 'New Booking',
      time: '1 week ago'
    }
  ];

  private _messages = [
    {
      name: 'Nasta',
      text: 'Lorem ipsum dolor sit amet.',
      time: '1 min ago'
    },
    {
      name: 'Vlad',
      text: 'Sed mollis tortor et nisi.',
      time: '2 hrs ago'
    },
    {
      name: 'Kostya',
      text: 'Nunc vulputate augue id elit.',
      time: '10 hrs ago'
    },
    {
      name: 'Andrey',
      text: 'Sed quis commodo turpis. Integer.',
      time: '1 day ago'
    },
    {
      name: 'Nasta',
      text: 'Nullam felis sapien, elementum ac.',
      time: '1 day ago'
    },
    {
      name: 'Kostya',
      text: 'Curabitur massa felis, eleifend et.',
      time: '2 days ago'
    },
    {
      name: 'Vlad',
      text: 'Integer efficitur placerat ex, vitae.',
      time: '1 week ago'
    }
  ];

  public getMessages():Array<Object> {
    return this._messages;
  }

  public getNotifications():Array<Object> {
    return this._notifications;
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiMsgCenter/ubiMsgCenter.service.ts